import isEmpty from 'lodash/isEmpty'

export const removeBlankProperty = (obj = {}) => {
  for (var propName in obj) {
    if (isEmpty(obj[propName]) || !obj[propName]) {
      delete obj[propName]
    }
  }
  return obj
}
